function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storeGuaranteeOptions, storeGuaranteeGroupList, storeGuaranteeGroupSave, storeGuaranteeGroupUpdate, storeGuaranteeGroupDelete } from '@/api/distributionStore';
export default {
  name: 'DistributionStoreGuarantee',
  data: function data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      rows: [],
      options: [],
      form: this.emptyForm(),
      rules: {
        name: [{
          required: true,
          message: '请输入组合名称',
          trigger: 'blur'
        }],
        ids: [{
          type: 'array',
          required: true,
          min: 1,
          message: '请至少选择一项保障条款',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.load();
  },
  methods: {
    emptyForm: function emptyForm() {
      return {
        id: null,
        name: '',
        ids: []
      };
    },
    load: function load() {
      var _this = this;
      this.loading = true;
      Promise.all([storeGuaranteeGroupList(), storeGuaranteeOptions()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          rows = _ref2[0],
          options = _ref2[1];
        _this.rows = rows || [];
        _this.options = options || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    openEditor: function openEditor(row) {
      this.form = row ? {
        id: row.id,
        name: row.name,
        ids: (row.guaranteeList || []).map(function (item) {
          return item.id;
        })
      } : this.emptyForm();
      this.visible = true;
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var data = {
          id: _this2.form.id,
          name: _this2.form.name,
          gids: _this2.form.ids.join(',')
        };
        _this2.saving = true;
        var request = data.id ? storeGuaranteeGroupUpdate(data) : storeGuaranteeGroupSave(data);
        request.then(function () {
          _this2.$message.success('保存成功');
          _this2.visible = false;
          _this2.load();
        }).finally(function () {
          _this2.saving = false;
        });
      });
    },
    remove: function remove(row) {
      var _this3 = this;
      this.$modalSure('删除当前保障组合吗？').then(function () {
        return storeGuaranteeGroupDelete(row.id);
      }).then(function () {
        _this3.$message.success('删除成功');
        _this3.load();
      });
    },
    clearForm: function clearForm() {
      this.form = this.emptyForm();
      if (this.$refs.form) this.$refs.form.clearValidate();
    }
  }
};